import { transformHostInfoData } from "../../../../../utils/helpers";

import { BoxWrapper } from "../../../../../components";
import { WidgetRow } from "../../../../../components/common/WidgetRow/WidgetRow";
import { useTranslateData } from "./data";

import { Wrapper } from "./HostInfo.styled";

export const HostInfo = ({ backData }) => {
  let data = useTranslateData();
  if (backData) {
    data = transformHostInfoData(data, backData);
  }
  return (
    <BoxWrapper>
      <Wrapper>
        {data?.map((item, ind) => (
          <WidgetRow key={ind} item={item} between={item?.between} />
        ))}
      </Wrapper>
    </BoxWrapper>
  );
};
